import { render, staticRenderFns } from "./LogoFigmaIcon.vue?vue&type=template&id=4337b8c2&"
import script from "./LogoFigmaIcon.vue?vue&type=script&lang=js&"
export * from "./LogoFigmaIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports